import noScroll from 'no-scroll';

import buildComponent from './utils/build-component';
import debounce from './utils/debounce';
import touchMoveMenu from './utils/touch-move-menu';

export default (nameSpace) => buildComponent({
  nameSpace,
  initState: {
    menuIsOpen: false,
    scrollType: '',
    isOnTop: true,
    lastScrollPosition: 0,
  },
  initFunction: ($el, params) => {
    const THRESHOLD = 30;
    const $scrollListener = document.querySelector('.scroll-listener')
    const $menuToggler = $el.querySelector(`.${nameSpace}__menu-toggler`);
    const $panel = $el.querySelector(`.${nameSpace}__panel`);
    const $panelInner = $el.querySelector(`.${nameSpace}__panel__inner`);

    //
    // Methods
    //

    function onMenuTogglerClick() {
      params.setState(prevState => {
        const newState = {
          menuIsOpen: !prevState.menuIsOpen,
        };
        return newState;
      });
    }

    const onScrollUpdate = debounce((scrollPos) => {
      window.requestAnimationFrame(() => {
        params.setState(prevState => {
          const obj = {}
          // Prevent listening iOS mobile bounce effect
          // Check only above the THRESHOLD
          if (scrollPos >= 0 && Math.abs(scrollPos - prevState.lastScrollPosition) > THRESHOLD) {
            if (
              scrollPos < THRESHOLD &&
              !prevState.isOnTop &&
              document.documentElement.style.position !== 'fixed' // noScroll lib check
            ) {
              obj.isOnTop = true;
            } else if (scrollPos >= THRESHOLD && prevState.isOnTop) {
              obj.isOnTop = false;
            }
            if (prevState.lastScrollPosition < scrollPos && prevState.scrollType !== 'down') {
              obj.scrollType = 'down';
            } else if (prevState.lastScrollPosition > scrollPos) {
              if (prevState.scrollType !== 'up') {
                obj.scrollType = 'up'
              }
              if (prevState.theme !== 'dark') {
                obj.theme = 'dark'
              }
            }
            obj.lastScrollPosition = scrollPos;
          }
          return obj;
        })  
      })
    }, 300)

    //
    // Life Cycle
    //

    params.onStateUpdate((newState, prevState) => {
      if (!prevState.menuIsOpen && newState.menuIsOpen) {
        $el.classList.add(`${nameSpace}--menu-is-open`);
      }
      if (prevState.menuIsOpen && !newState.menuIsOpen) {
        $el.classList.remove(`${nameSpace}--menu-is-open`);
      }

      if (prevState.scrollType !== 'down' && newState.scrollType === 'down') {
        $el.classList.add(`${nameSpace}--scroll-down`);
      }
      if (prevState.scrollType !== 'up' && newState.scrollType === 'up') {
        $el.classList.remove(`${nameSpace}--scroll-down`);
      }

      if (!prevState.isOnTop && newState.isOnTop) {
        $el.classList.add(`${nameSpace}--is-on-top`);
      }
      if (prevState.isOnTop && !newState.isOnTop) {
        $el.classList.remove(`${nameSpace}--is-on-top`);
      }

      if (prevState.menuIsOpen !== newState.menuIsOpen) {
        if (newState.menuIsOpen) {
          noScroll.on();
        } else {
          noScroll.off();
        }
      }
    })


    //
    // Procedures
    //

    touchMoveMenu({
      $el: $panel,
      panel: $panelInner,
      breakpoint: 1000,
      direction: 'RIGHT',
      open: () => params.setState({ menuIsOpen: true }),
      close: () => params.setState({ menuIsOpen: false }),
      checkOpenState: () => params.getState().menuIsOpen,
    });

    //
    // Listeners / Observers
    //

    $menuToggler.addEventListener('click', onMenuTogglerClick);

    $scrollListener.Component['scroll-listener'].addObserver((state) => onScrollUpdate(state.scrollTop))

    //
    // Public API
    //

    return {
    };
  },
});


// WEBPACK FOOTER //
// ./src/scripts/header.js